/* eslint-disable */
import { enums } from "../enums";
import { ACTION_TYPE } from "../actions/ActionTypes";

const INITIAL_STATE = {
  currentOrganization: {
    _id: undefined,
    name: '',
    blockchainAddress:'',
    contactFirstName:'',
    contactLastName:'',
    contactPhoneNumber:'',
    contactEmail:'',
    type: enums.OrganizationTypes.CUSTOMER,
    matchingType: {},
    parentOrganization:{},
    automaticMatchingLiveEnabled: false,
    automaticMatchingOfficialEnabled: false
  },
  organizationBalanceAccount: null,
  localOrganizationPicture: null,
  organizations: [],
  organizationsForMonthlyReport: [],
  customerOrganizations: [],
  utilityOrganizations: [],
  parentOrganizations: [],
  organizationUsers: [],
  organizationAssetsProducing: [],
  organizationAssetsConsuming: [],
  error: { message: '', isVisible: false },
  loading: false,
  loadingForm: false,
  order: 'asc',
  orderBy: 'id',
  selected: [],
  page: 0,
  rowsPerPage: 10,
};

const organizationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

  case "SORT_ORGANIZATIONS":
    const organizations = action.payload.organizations;
    const order = action.payload.order;
    const orderBy = action.payload.orderBy;
    return { ...state, organizations, order, orderBy };

  case "SORT_ORGANIZATION_USERS":
    const organizationUsers = action.payload.organizationUsers;
    const orderOrganizationUsers = action.payload.order;
    const orderByOrganizationUsers = action.payload.orderBy;
    return { ...state, organizationUsers, order: orderOrganizationUsers, orderBy: orderByOrganizationUsers };

  case "SORT_ORGANIZATION_PRODUCING_ASSETS":
    const organizationAssetsProducing = action.payload.organizationAssetsProducing;
    const orderOrganizationProdAssets = action.payload.order;
    const orderByOrganizationProdAssets = action.payload.orderBy;
    return { ...state, organizationAssetsProducing, order: orderOrganizationProdAssets, orderBy: orderByOrganizationProdAssets };

    case "SORT_ORGANIZATION_CONSUMING_ASSETS":
      const organizationAssetsConsuming = action.payload.organizationAssetsConsuming;
      const orderOrganizationConsAssets = action.payload.order;
      const orderByOrganizationConsAssets = action.payload.orderBy;
      return { ...state, organizationAssetsConsuming, order: orderOrganizationConsAssets, orderBy: orderByOrganizationConsAssets  };

  case "CHANGE_PAGE":
    const page = action.payload.page;
    return { ...state, page };

  case "CHANGE_ROWS_PER_PAGE":
    const rowsPerPage = action.payload.rowsPerPage;
    return { ...state, rowsPerPage };


  case 'GET_ORGANIZATIONS_START':
    return { ...state, loading: true }

  case 'GET_ORGANIZATIONS_SUCCESS':
    return {
      ...state,
      organizations: action.payload,
      organizationsForMonthlyReport: action.payload.filter(org => org.generateMonthlyPdfCertificateReport),
      customerOrganizations: action.payload.filter(org => org.type === enums.OrganizationTypes.CUSTOMER),
      utilityOrganizations: action.payload.filter(org => org.type === enums.OrganizationTypes.UTILITY),
      loading: false
    }

  case 'GET_UTILITY_ORGANIZATION_BALANCE_ACCOUNT_SUCCESS':
    return { ...state, organizationBalanceAccount: action.payload }
    

  case 'GET_ORGANIZATIONS_FAIL':
    return { ...state, loading: false }

  case 'GET_PARENT_ORGANIZATIONS_START':
    return { ...state, loading: true }

  case 'GET_PARENT_ORGANIZATIONS_SUCCESS':
    return { ...state, parentOrganizations: action.payload, loading: false }

  case 'GET_PARENT_ORGANIZATIONS_FAIL':
    return { ...state, loading: false }

  case 'GET_ORGANIZATION_START':
    return { ...state, loading: true }

  case 'GET_ORGANIZATION_SUCCESS':
    return { ...state, currentOrganization: action.payload, loading: false }

  case 'GET_ORGANIZATION_FAIL':
    return { ...state, loading: false }

  case 'GET_ORGANIZATION_CONSUMING_ASSETS_START':
    return { ...state, loading: true }

  case 'GET_ORGANIZATION_CONSUMING_ASSETS_SUCCESS':
    return { ...state, organizationAssetsConsuming: action.payload, loading: false }

  case 'GET_ORGANIZATION_CONSUMING_ASSETS_FAIL':
    return { ...state, loading: false }

  case 'GET_ORGANIZATION_PRODUCING_ASSETS_START':
    return { ...state, loading: true }

  case 'GET_ORGANIZATION_PRODUCING_ASSETS_SUCCESS':
    return { ...state, organizationAssetsProducing: action.payload, loading: false }

  case 'GET_ORGANIZATION_PRODUCING_ASSETS_FAIL':
    return { ...state, loading: false }

  case 'GET_ORGANIZATION_USERS_START':
    return { ...state, loading: true }

  case 'GET_ORGANIZATION_USERS_SUCCESS':
    return { ...state, organizationUsers: action.payload, loading: false }

  case 'GET_ORGANIZATION_USERS_FAIL':
    return { ...state, loading: false }

  case 'GET_ORGANIZATION_FORM_START':
    return { ...state, loadingForm: true }

  case 'GET_ORGANIZATION_FORM_SUCCESS':
    return { ...state, currentOrganization: action.payload, loadingForm: false }

  case 'GET_ORGANIZATION_FORM_FAIL':
    return { ...state, loadingForm: false }

  case 'CREATE_ORGANIZATION_START':
    return { ...state, loading: true }

  case 'CREATE_ORGANIZATION_SUCCESS':
    return { ...state, loading: false, currentOrganization: INITIAL_STATE }

  case 'CREATE_ORGANIZATION_FAIL':
    return { ...state, loading: false }


  case 'UPDATE_ORGANIZATION_START':
    return { ...state, loading: true }

  case 'UPDATE_ORGANIZATION_SUCCESS':
    return { ...state, loading: false }

  case 'UPDATE_ORGANIZATION_FAIL':
    return { ...state, loading: false }



  case "ORGANIZATION_PICTURE_CHANGED":
    return {
      ...state,
      localOrganizationPicture: action.payload
  };


  case 'ORGANIZATION_BLOCKCHAIN_ADDRESS_CHANGED':

    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        blockchainAddress: action.payload,
      }
    }

  case 'ORGANIZATION_TYPE_CHANGED':
    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        type: action.payload,
      }
    }

  case 'ORGANIZATION_PARENT_ORGANIZATION_CHANGED':
    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        parentOrganization: { _id : action.payload},
      }
    }

  case 'ORGANIZATION_MATCHING_TYPE_CHANGED':
    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        matchingType: { _id : action.payload},
      }
    }

  case 'ORGANIZATION_CONTACT_FIRSTNAME_CHANGED':

    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        contactFirstName: action.payload,
      }
    }

  case 'ORGANIZATION_CONTACT_LASTNAME_CHANGED':

    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        contactLastName: action.payload,
      }
    }

  case 'ORGANIZATION_CONTACT_PHONENUMBER_CHANGED':

    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        contactPhoneNumber: action.payload,
      }
    }

  case 'ORGANIZATION_CONTACT_EMAIL_CHANGED':

    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        contactEmail: action.payload,
      }
    }
    
  case ACTION_TYPE.ORGANIZATION.AUTOMATIC_MATCHING_LIVE_ENABLED_CHANGED:
    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        automaticMatchingLiveEnabled: action.payload,
      }
    }
    
  case ACTION_TYPE.ORGANIZATION.AUTOMATIC_MATCHING_OFFICIAL_ENABLED_CHANGED:
    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        automaticMatchingOfficialEnabled: action.payload,
      }
    }

  case 'ORGANIZATION_NAME_CHANGED':

    return {
      ...state,
      currentOrganization: {
        ...state.currentOrganization,
        name: action.payload,
      }
    }

  case "RESET_ORGANIZATION":
    return {
      ...state,
      currentOrganization: {
        _id: undefined,
        name: '',
        blockchainAddress:'',
        contactFirstName:'',
        contactLastName:'',
        contactPhoneNumber:'',
        contactEmail:'',
        type: enums.OrganizationTypes.CUSTOMER,
        matchingType: 'matching_type_1',
      },
      localOrganizationPicture: null
    };

  default:
    return state
  }
}

export default organizationsReducer



// WEBPACK FOOTER //
// ./src/reducers/organizationsReducer.js